module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"FacebookWidgetPage":{"title":"Facebook plugin"}}}')
  delete Component.options._Ctor
}
